export const getTranslations = t => {
  return {
    search: t("kf.pdp.label.searchBtn"),
  }
}
